import Loadable from 'my-components/Loadable';

export default Loadable(() => import(/* webpackChunkName: "latex" */ './Latex'), { fallback: <span>...</span> });
